import { Box, DollarSign, Package } from "lucide-react";
import { FC } from "react";
import { useGetInventoryMetrics } from "~/services/inventory/inventory.queries";

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    value
  );

const formatVolume = (value: number) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value) +
  " ft³";

export const MetricInventories: FC = () => {
  const { data, isLoading, isError } = useGetInventoryMetrics();

  if (isLoading) {
    return (
      <div className="mb-6">
        <div className="bg-white rounded-lg border shadow-sm p-4">
          <div className="text-center text-gray-500">Loading metrics...</div>
        </div>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className="mb-6">
        <div className="bg-white rounded-lg border shadow-sm p-4">
          <div className="text-center text-red-500">Failed to load metrics</div>
        </div>
      </div>
    );
  }

  // const { totalInventory, totalValue, totalStorageSpace, monthlyRevenue } =
  const { totalInventory, totalStorageSpace, monthlyRevenue } = data;
  const totalItems =
    totalInventory.packages + totalInventory.pieces + totalInventory.parts;
  // const avgValuePerItem = totalItems > 0 ? totalValue / totalItems : 0;
  const costPerCubicFoot =
    totalStorageSpace > 0 ? monthlyRevenue / totalStorageSpace : 0;

  return (
    <div className="mb-6">
      <div className="bg-white rounded-lg border shadow-sm p-4">
        <div className="grid grid-cols-4 divide-x">
          <div className="px-4">
            <div className="flex items-center space-x-2">
              <Package size={16} className="text-blue-600" />
              <span className="text-sm text-gray-500">Total Inventory</span>
            </div>
            <div className="mt-1 text-xl font-semibold">{totalItems}</div>
            <div className="text-xs text-gray-500">
              {totalInventory.packages} packages, {totalInventory.pieces}{" "}
              pieces, {totalInventory.parts} parts
            </div>
          </div>

          <div className="px-4">
            <div className="flex items-center space-x-2">
              <DollarSign size={16} className="text-green-600" />
              <span className="text-sm text-gray-500">Total Value</span>
            </div>
            <div className="mt-1 text-xl font-semibold">
              {/* {formatCurrency(totalValue)} */}
              Null
            </div>
            <div className="text-xs text-gray-500">
              {/* Avg: {formatCurrency(avgValuePerItem)}/item */}
              Avg: Null
            </div>
          </div>

          <div className="px-4">
            <div className="flex items-center space-x-2">
              <Box size={16} className="text-purple-600" />
              <span className="text-sm text-gray-500">Storage Space</span>
            </div>
            <div className="mt-1 text-xl font-semibold">
              {formatVolume(totalStorageSpace)}
            </div>
            <div className="text-xs text-gray-500">
              {formatCurrency(costPerCubicFoot)}/ft³/month
            </div>
          </div>

          <div className="px-4">
            <div className="flex items-center space-x-2">
              <DollarSign size={16} className="text-amber-600" />
              <span className="text-sm text-gray-500">Monthly Revenue</span>
            </div>
            <div className="mt-1 text-xl font-semibold">
              {/* {formatCurrency(monthlyRevenue)} */}
              Null
            </div>
            <div className="text-xs text-gray-500">From inventory items</div>
          </div>
        </div>
      </div>
    </div>
  );
};
